import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  responseType: "json",
  timeout: 30000,
});
const instance2 = axios.create({
  baseURL: process.env.REACT_APP_API2_BASE_URL,
  responseType: "json",
  timeout: 30000,
});

instance.interceptors.response.use((response) => {
  return response;
});

// 薬局情報, 物品情報取得API
export const getPaymentInfo = async (receiptedNumber, paymentId) => {
  return instance.get(
    "/paymentInformation?receiptedNumber=" +
      receiptedNumber +
      "&paymentId=" +
      paymentId
  );
};

export const postCompleted = async (data) => {
  return instance.post("/medicalAccounting", data);
};
export const postPaymentStart = async (data) => {
  return instance2.post("/postPaymentStart", data);
};
